/**
 * @license
 * @copyright Copyright Motili Inc., 2021 All Rights Reserved
 */

import { ReactElement } from 'react';
import { Heading1, Paragraph } from '@motili/ui';
import CenteredContainer from '../../../components/layout/CenteredContainer';
import { styled } from 'styled-components';
import { useAppSelector } from '../../../common/redux/hooks';
import FinancesForm from './FinancesForm';
import BottomButtonNavigation from '../../../navigation/BottomButtonNavigation';

interface FinancesProps {
    handleBackClick: () => void;
    handleNextClick: () => void;
}

export default function Finances({
    handleBackClick,
    handleNextClick,
}: FinancesProps): ReactElement {
    const accountsPayableRepresentative =
        useAppSelector(
            ({ clientRegistration }) =>
                clientRegistration.client.accountsPayableRepresentative
        ) || {};
    const steps = useAppSelector(
        ({ clientRegistration }) => clientRegistration.client.totalSteps
    );

    return (
        <CenteredContainer>
            <Paragraph>
                <BoldText>Step 3</BoldText> of {steps}
            </Paragraph>
            <Heading1>Finances</Heading1>
            <Paragraph>
                In order to onboard our clients, we will need a contact to
                discuss finances with. We will also need to understand Please
                specify the contact below we will need to speak with.
            </Paragraph>
            <Paragraph>
                Please provide contact information for your{' '}
                <b>Accounts Payable</b> representative:
            </Paragraph>
            <FinancesForm
                accountsPayableRepresentative={accountsPayableRepresentative}
            />
            <BottomButtonNavigation
                onBackClick={handleBackClick}
                onNextClick={handleNextClick}
                nextDisabled={
                    !accountsPayableRepresentative.firstName ||
                    !accountsPayableRepresentative.lastName ||
                    !accountsPayableRepresentative.email ||
                    accountsPayableRepresentative?.phone?.length !== 10
                }
            />
        </CenteredContainer>
    );
}

const BoldText = styled.span`
    font-weight: bold;
`;
